export default "__VITE_ASSET__XFlHmqlp__"